export const PATH_WALLET = "/member/wallet";
